<template>
  <div class="product-detail-container page-common-detail-container">
    <div class="detail__wrapper" v-if="product">
      <div class="detail__title">{{ product.name }}</div>
      <!-- 轮播 -->
      <DetailSwiper :pictures="pictures" enable-preview></DetailSwiper>
      <!-- 详细参数 -->
      <template v-if="$isMobile">
        <div class="mobile-detail-parameters-container">
          <!-- <div class="detail-main-info-container detail__child">
            <p>{{ product.name }}</p>
            <p>￥{{ product.min_price }} - ￥{{ product.max_price }}</p>
          </div> -->
          <router-link class="detail-store-info detail__child" tag="div" :to="{
            path: `/merchant/${product.store_id}/cases`
          }">
            <div class="store-logo">
              <div class="__logo" :data-name="product.storeDetail.name">
                <img :src="product.storeDetail.logo_picture_url | parseImage" alt="" />
              </div>
            </div>
            <div class="store-info">
              <div class="info__item">{{ product.storeDetail.name }}</div>
              <div class="info__item">
                <div class="info__child">
                  <sign style="margin:0 10px 0 0;" :sign="product.storeDetail.sign"
                    v-if="Number(product.storeDetail.type) === 1 && Number(product.storeDetail.sign) > 0"></sign>
                </div>
                <div class="info__child">
                  <p class="type__text">
                    {{
                      Number(product.storeDetail.type) === 2
                      ? "认证经销商"
                      : Number(product.storeDetail.type) === 1
                        ? "厂家直营店"
                        : ""
                    }}
                  </p>
                  <el-rate class="type__rate" disabled v-model="stars"></el-rate>
                </div>
              </div>
              <div class="info__item">{{ product.place }}</div>
            </div>
          </router-link>
          <div class="detail-other-params-container detail__child">
            <p><span>分类：</span>{{ product.mold_name }}</p>
            <p><span>尺寸：</span>{{ product.size }}</p>
            <p><span>产地：</span>{{ product.place }}</p>
            <p><span>品牌：</span>{{ product.brand }}</p>
            <p><span>型号：</span>{{ product.model }}</p>
            <p><span>风格：</span>{{ product.style }}</p>
            <p><span>吸水率：</span>{{ product.absorption }}</p>
            <p><span>价格：</span>￥{{ product.min_price }} - ￥{{ product.max_price }}</p>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="more-detail-parameters-container">
          <router-link class="param__item __logo hoverinto" :data-name="product.storeDetail.name" tag="div" :to="{
            path: `/merchant/${product.store_id}/cases`
          }">
            <img :src="product.storeDetail.logo_picture_url | parseImage" alt="" />
          </router-link>
          <div class="param__item __base-info">
            <p class="info__name">{{ product.storeDetail.name }}</p>
            <div class="base__type">
              <div class="type__child">
                <sign style="margin:0 10px 0 0;" :sign="product.storeDetail.sign"
                  v-if="Number(product.storeDetail.type) === 1 && Number(product.storeDetail.sign) > 0"></sign>
              </div>
              <div class="type__child">
                <p class="type__text">
                  {{
                    Number(product.storeDetail.type) === 2
                    ? "认证经销商"
                    : Number(product.storeDetail.type) === 1
                      ? "厂家直营店"
                      : ""
                  }}
                </p>
                <el-rate class="type__rate" disabled v-model="stars"></el-rate>
              </div>
            </div>
            <p class="base__bt">{{ product.place }}</p>
          </div>
          <div class="param__item __params">
            <div class="param__body">
              <p><span>分类：</span>{{ product.mold_name }}</p>
              <p><span>产地：</span>{{ product.place }}</p>
              <p><span>型号：</span>{{ product.model }}</p>
              <p><span>吸水率：</span>{{ product.absorption }}</p>
            </div>
          </div>
          <div class="param__item __params">
            <div class="param__body">
              <p><span>尺寸：</span>{{ product.size }}</p>
              <p><span>品牌：</span>{{ product.brand }}</p>
              <p><span>风格：</span>{{ product.style }}</p>
              <p><span>价格：</span>￥{{ product.min_price }} - ￥{{ product.max_price }}</p>
            </div>
          </div>
        </div>
      </template>
      <!-- 详情 -->
      <div class="detail__multi-info mobileActionShowSign">
        <div class="info__head">
          <div class="head__item" :class="[currentShow === 'detail' ? 'active' : '']" @click="currentShow = 'detail'">材料详情
          </div>
          <div class="head__item" :class="[currentShow === 'moreParams' ? 'active' : '']" v-if="userInfo.identity != 4"
            @click="currentShow = 'moreParams'">更多参数</div>
        </div>
        <div class="info__content" v-html="product.content" v-if="currentShow === 'detail'"></div>
        <div class="info__content" v-if="currentShow === 'moreParams'">
          <p>表面效果：{{ product.effect_tags }}</p>
          <p>是否常用产品：{{ product.is_commonly == 1 ? '是' : '否' }}</p>
          <p>是否可定制效果：{{ product.is_customized == 1 ? '是' : '否' }}</p>
          <div>
            <p>安装施工要点：</p>
            <p v-for="(item, index) in product.install_pivot" :key="index">
              {{ item }}
            </p>
          </div>
          <p>SU材质贴图：</p>
          <el-image v-for="(item, index) in product.su_desc" :key="index" fit="cover" class="img"
            :src="item.url | parseImage"></el-image>
          <p>做法详图：</p>
          <el-image v-for="(item, index) in product.install_desc" :key="index" fit="cover" class="img"
            :src="item.url | parseImage"></el-image>
        </div>
      </div>
      <!-- 按钮 -->
      <detail-bottom-bts :is-collect="product.is_collection === 1" :id="Number(product.id)"
        :type="$dict.COLLECT_TYPE.product" :qrcode="product.qrcode_url"></detail-bottom-bts>
      <!-- 评论 -->
      <div class="detail__reply-form" v-if="!$isMobile">
        <div class="form__textarea">
          <textarea placeholder="在这里你可以说些什么" v-model="text.reply"></textarea>
        </div>
        <el-button :loading="loading.reply" class="form__submit" @click="onReply">评论</el-button>
      </div>
      <!-- 评论列表 -->
      <template v-if="product && product.commentList.length > 0">
        <reply-list :lists="product.commentList"></reply-list>
      </template>
    </div>
    <div class="detail__recommend-container">
      <div class="recommend__wrapper">
        <div class="recommend__merchants-container">
          <div class="recommend__title">
            <p>
              ARTICLE
            </p>
            <p>
              推荐文章
            </p>
          </div>
          <div class="recommend__lists-wrapper">
            <recommendArticleList ref="recommendArticleList" theme="swiper"></recommendArticleList>
          </div>
        </div>
      </div>
    </div>
    <template v-if="$isMobile">
      <action-hint :bts="[
        {
          text: '收藏',
          bg: '#007fd9',
          color: '#fff'
        }
      ]"></action-hint>
    </template>
  </div>
</template>

<script>
import actionHint from '@/pages/common/mobile-action-hint.vue';
import DetailSwiper from '@/pages/common/detailSwiper.vue';
import DetailBottomBts from '@/pages/common/detailBottomBts.vue';
import ReplyList from '@/pages/common/replies.vue';
import { handlerDetailReply } from '@/assets/utils/handler';
import { mapState } from 'vuex';
import recommendArticleList from '@/components/recommendArticleList.vue';
import Sign from '@/pages/merchant/_sign.vue'

export default {
  props: ['id'],
  components: {
    DetailSwiper,
    DetailBottomBts,
    ReplyList,
    actionHint,
    recommendArticleList,
    Sign
  },
  data() {
    return {
      pictures: [],
      product: null,
      stars: 5,
      loading: {
        reply: false,
      },
      text: {
        reply: '',
      },
      currentShow: 'detail',
    };
  },
  computed: mapState('user', {
    userInfo: (state) => state.info || {},
  }),
  watch: {
    $route: {
      handler: 'init',
      immediate: true,
    },
  },
  methods: {
    init() {
      this.$store.commit('SET_LOGIN_TITLE', '如何收藏？');
      this.$store.commit('openLoading');
      this.$http
        .post('html/product/productDetail', {
          id: this.id,
        })
        .then((res) => {
          if (res.data.install_pivot) res.data.install_pivot = res.data.install_pivot.split('\n')
          const { data } = res;
          this.product = data;
          this.pictures = this.product.picture_ids;
          this.$nextTick(() => {
            this.$refs.recommendArticleList.getList(res.data.mold_id || res.data.storeDetail.mold_id)
          })
        })
        .finally(() => {
          this.$store.commit('closeLoading');
        });
    },
    onReply() {
      this.loading.reply = true;
      handlerDetailReply(this.product.id, this.text.reply, this.$dict.COLLECT_TYPE.product)
        .then(() => {
          this.$message({
            type: 'success',
            message: '评论成功',
          });
          this.product.commentList.push({
            id: -1,
            can_del: -1,
            centent: this.text.reply,
            ctime: Math.floor(new Date().getTime() / 1000),
            fabulous_num: 0,
            picture_ids: [],
            user_id: this.userInfo.id,
            avatar: this.userInfo.avatar,
            user_name: this.userInfo.nickname,
          });
          this.text.reply = '';
        })
        .finally(() => {
          this.loading.reply = false;
        });
    },
  },
};
</script>

<style>
.page-common-detail-container .detail__multi-info .info__content .img img {
  margin: 0 auto 10px;
}
</style>
